import React, { useEffect, useState } from "react";
import { Card, CardBody, Col, Row, Button } from "reactstrap";
import { Field, reduxForm } from "redux-form";
import axios from "axios";
import Swal from "sweetalert2";

import Titlebanner from "../../../globel_cmponents/title_banner";
import RenderField from "../../formcomponent/formfields/RenderField";
import requests from "../../../utils/Requests";
import ApiAgentMarkupTable from "./Tables/ApiAgentMarkupTable";

const validate = (values) => {
  const errors = {};

  if (!values.apiId || Number(values.apiId) === 0) {
    errors.apiId = "Required";
  }
  if (!values.attractionGroupId || Number(values.attractionGroupId) === 0) {
    errors.attractionGroupId = "Required";
  }
  if (!values.attractionId || Number(values.attractionId) === 0) {
    errors.attractionId = "Required";
  }
  if (!values.agentId || Number(values.agentId) === 0) {
    errors.agentId = "Required";
  }
  if (!values.ticketTypeId || Number(values.ticketTypeId) === 0) {
    errors.ticketTypeId = "Required";
  }
  if (!values.primeAdultPrice) {
    errors.primeAdultPrice = "Required";
  } else if (isNaN(Number(values.primeAdultPrice))) {
    errors.primeAdultPrice = "Must be a number";
  }
  if (!values.nonPrimeAdultPrice) {
    errors.nonPrimeAdultPrice = "Required";
  } else if (isNaN(Number(values.nonPrimeAdultPrice))) {
    errors.nonPrimeAdultPrice = "Must be a number";
  }
  if (!values.primeChildPrice) {
    errors.primeChildPrice = "Required";
  } else if (isNaN(Number(values.primeChildPrice))) {
    errors.primeChildPrice = "Must be a number";
  }
  if (!values.nonPrimeChilPrice) {
    errors.nonPrimeChilPrice = "Required";
  } else if (isNaN(Number(values.nonPrimeChilPrice))) {
    errors.nonPrimeChilPrice = "Must be a number";
  }

  return errors;
};

const ApiAgentMarkup = (props) => {
  const { handleSubmit, reset, initialize, change } = props;

  const defaultGroupOption = { label: "Select Attraction Group", value: "0" };
  const defaultAttractionOption = { label: "Select Attraction", value: "0" };
  const defaultTicketOption = { label: "Select Ticket Type", value: "0" };

  const [groupOptions, setGroupOptions] = useState([defaultGroupOption]);
  const [attractionOptions, setAttractionOptions] = useState([defaultAttractionOption]);
  const [agentOptions, setAgentOptions] = useState([{ label: "Select Agent", value: "0" }]);
  const [ticketTypeOptions, setTicketTypeOptions] = useState([defaultTicketOption]);
  const [selectedGroup, setSelectedGroup] = useState("0");
  const [selectedAttraction, setSelectedAttraction] = useState("0");
  const [isEditing, setIsEditing] = useState(false);
  const [disableSelect, setDisableSelect] = useState(false);
  const [refreshKey, setRefreshKey] = useState(0);

  const apiOptions = [
    { label: "Select API", value: "0" },
    { label: "Burj Khalifa", value: "1" },
    { label: "Museum Of The Future", value: "2" },
  ];

  useEffect(() => {
    fetchAgents();
    fetchGroups();
  }, []);

  useEffect(() => {
    initialize({
      apiId: "0",
      attractionGroupId: "0",
      attractionId: "0",
      agentId: "0",
      ticketTypeId: "0",
      primeAdultPrice: "",
      nonPrimeAdultPrice: "",
      primeChildPrice: "",
      nonPrimeChilPrice: "",
      apiAgentMarkupId: 0,
    });
  }, [initialize]);

  const fetchAgents = () => {
    axios
      .post(requests.getagencylist, {
        platformId: 1,
        attractionsId: 1,
        secretKey: requests.apiKey,
      })
      .then((res) => {
        const values = [
          {
            label: "Select Agent",
            value: "0",
          },
          ...res.data.map((item) => ({
            label: item.agencyName,
            value: String(item.agencyId),
          })),
        ];
        setAgentOptions(values);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchGroups = () => {
    axios
      .post(requests.getallparkgroup, { attractionsId: 0 })
      .then((res) => {
        const values = [
          defaultGroupOption,
          ...res.data.map((item) => ({
            label: item.grpName,
            value: String(item.attractionGroupId),
          })),
        ];
        setGroupOptions(values);
      })
      .catch((err) => console.log(err));
  };

  const fetchAttractionsByGroup = (groupId, { resetSelection = true } = {}) => {
    if (!groupId || groupId === "0") {
      setAttractionOptions([defaultAttractionOption]);
      if (resetSelection) {
        setSelectedAttraction("0");
        change("attractionId", "0");
      }
      setTicketTypeOptions([defaultTicketOption]);
      change("ticketTypeId", "0");
      return Promise.resolve([]);
    }

    return axios
      .post(requests.getattractionallbygroup, { attGroup: Number(groupId) })
      .then((res) => {
        const attractionOpts = [
          defaultAttractionOption,
          ...res.data.map((item) => ({
            label: item.attName,
            value: String(item.attractionsId),
          })),
        ];
        setAttractionOptions(attractionOpts);
        if (resetSelection) {
          setSelectedAttraction("0");
          change("attractionId", "0");
          setTicketTypeOptions([defaultTicketOption]);
          change("ticketTypeId", "0");
        }
        return attractionOpts;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  };

  const fetchTicketTypesByAttraction = (attractionId, { resetSelection = true } = {}) => {
    if (!attractionId || attractionId === "0") {
      setTicketTypeOptions([defaultTicketOption]);
      if (resetSelection) {
        change("ticketTypeId", "0");
      }
      return Promise.resolve([]);
    }
    return axios
      .post(requests.getTicketTypeListByAttraction, {
        ttAttractionId: Number(attractionId),
        platformId: 1,
      })
      .then((res) => {
        const ticketOpts = [
          defaultTicketOption,
          ...res.data.map((item) => ({
            label: item.ttTicketType,
            value: String(item.ticketTypeId),
          })),
        ];
        setTicketTypeOptions(ticketOpts);
        if (resetSelection) {
          change("ticketTypeId", "0");
        }
        return ticketOpts;
      })
      .catch((err) => {
        console.log(err);
        return [];
      });
  };

  const resetFormState = () => {
    reset();
    initialize({
      apiId: "0",
      attractionGroupId: "0",
      attractionId: "0",
      agentId: "0",
      ticketTypeId: "0",
      primeAdultPrice: "",
      nonPrimeAdultPrice: "",
      primeChildPrice: "",
      nonPrimeChilPrice: "",
      apiAgentMarkupId: 0,
    });
    setSelectedGroup("0");
    setSelectedAttraction("0");
    setAttractionOptions([defaultAttractionOption]);
    setTicketTypeOptions([defaultTicketOption]);
    setDisableSelect(false);
    setIsEditing(false);
    setRefreshKey((prev) => prev + 1);
  };

  const buildPayload = (values) => {
    const toNumber = (val) =>
      val === undefined || val === null || val === "" ? 0 : Number(val);

    return {
      apiAgentMarkupId: toNumber(values.apiAgentMarkupId),
      apiId: toNumber(values.apiId),
      attractionGroupId: toNumber(values.attractionGroupId),
      attractionId: toNumber(values.attractionId),
      agentId: toNumber(values.agentId),
      ticketTypeId: toNumber(values.ticketTypeId),
      primeAdultPrice: Number(values.primeAdultPrice),
      nonPrimeAdultPrice: Number(values.nonPrimeAdultPrice),
      primeChildPrice: Number(values.primeChildPrice),
      nonPrimeChilPrice: Number(values.nonPrimeChilPrice),
    };
  };

  const submitMarkup = (values, mode) => {
    const payload = buildPayload(values);

    const requestMap = {
      create: requests.setApiAgentMarkup,
      update: requests.updateApiAgentMarkup,
    };

    const url = requestMap[mode];

    axios
      .post(url, payload)
      .then((response) => {
        if (response.data.errCode === 0) {
          Swal.fire({
            title: "Success!",
            text:
              mode === "create"
                ? "Agent markup added successfully"
                : "Agent markup updated successfully",
            icon: "success",
          });
          resetFormState();
        } else {
          Swal.fire({
            title: "Warning!",
            text:
              response.data.errMessage ||
              "Something went wrong. Please try again.",
            icon: "warning",
          });
        }
      })
      .catch((error) => {
        console.log(error);
        Swal.fire({
          title: "Error!",
          text: "Unable to process request.",
          icon: "error",
        });
      });
  };

  const handleSave = (values) => {
    submitMarkup(values, "create");
  };

  const handleUpdate = (values) => {
    if (!values.apiAgentMarkupId) {
      Swal.fire({
        title: "Warning!",
        text: "Please select a record to update.",
        icon: "warning",
      });
      return;
    }
    submitMarkup(values, "update");
  };

  const handleEditRow = async (rowData) => {
    try {
      setDisableSelect(true);
      setIsEditing(true);

      const ticketTypeIdStr = String(rowData.ticketTypeId);
      const ticketTypeResponse = await axios.post(requests.gettickettypedetails, {
        ticketTypeId: Number(ticketTypeIdStr),
      });
      const ticketTypeDetails = ticketTypeResponse.data || {};
      const groupIdStr = String(ticketTypeDetails.ttGroupId || 0);
      const attractionIdStr = String(ticketTypeDetails.ttAttractionId || 0);

      setSelectedGroup(groupIdStr);
      await fetchAttractionsByGroup(groupIdStr, { resetSelection: false });
      setSelectedAttraction(attractionIdStr);
      await fetchTicketTypesByAttraction(attractionIdStr, { resetSelection: false });

      initialize({
        ...rowData,
        apiId: String(rowData.apiId),
        attractionGroupId: groupIdStr,
        attractionId: attractionIdStr,
        agentId: String(rowData.agentId),
        ticketTypeId: ticketTypeIdStr,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const handleCancel = () => {
    resetFormState();
  };

  const handleGroupChange = async (value) => {
    setSelectedGroup(value);
    change("attractionGroupId", value);
    await fetchAttractionsByGroup(value);
  };

  const handleAttractionChange = async (value) => {
    setSelectedAttraction(value);
    change("attractionId", value);
    await fetchTicketTypesByAttraction(value);
  };

  return (
    <>
      <Titlebanner title="Attraction API - Agent Markup" />
      <Card>
        <CardBody>
          <Row>
            <Col md="6">
              <Field
                name="apiId"
                label="API"
                component={RenderField.RenderSelectField}
                options={apiOptions}
                isDisabled={disableSelect}
              />
            </Col>
            <Col md="6">
              <Field
                name="attractionGroupId"
                label="Attraction Group"
                component={RenderField.RenderSelectField}
                options={groupOptions}
                isDisabled={disableSelect}
                onChange={handleGroupChange}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Field
                name="attractionId"
                label="Attraction"
                component={RenderField.RenderSelectField}
                options={attractionOptions}
                isDisabled={disableSelect || selectedGroup === "0"}
                onChange={handleAttractionChange}
              />
            </Col>
            <Col md="6">
              <Field
                name="agentId"
                label="Agent"
                component={RenderField.RenderSelectField}
                options={agentOptions}
                isDisabled={disableSelect}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Field
                name="ticketTypeId"
                label="Ticket Type"
                component={RenderField.RenderSelectField}
                options={ticketTypeOptions}
                isDisabled={disableSelect || selectedAttraction === "0"}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Field
                name="primeAdultPrice"
                type="number"
                label="Prime Adult Price"
                component={RenderField.RenderTextField}
              />
            </Col>
            <Col md="6">
              <Field
                name="nonPrimeAdultPrice"
                type="number"
                label="Non Prime Adult Price"
                component={RenderField.RenderTextField}
              />
            </Col>
          </Row>
          <Row>
            <Col md="6">
              <Field
                name="primeChildPrice"
                type="number"
                label="Prime Child Price"
                component={RenderField.RenderTextField}
              />
            </Col>
            <Col md="6">
              <Field
                name="nonPrimeChilPrice"
                type="number"
                label="Non Prime Child Price"
                component={RenderField.RenderTextField}
              />
            </Col>
          </Row>
          <div className="float-right">
            <Button
              color="success"
              onClick={handleSubmit(handleSave)}
              className="mr-2"
              disabled={isEditing}
            >
              Save
            </Button>
            <Button
              color="primary"
              onClick={handleSubmit(handleUpdate)}
              className="mr-2"
            >
              Update
            </Button>
            <Button color="danger" onClick={handleCancel}>
              Cancel
            </Button>
          </div>
        </CardBody>
      </Card>

      <ApiAgentMarkupTable
        onEdit={handleEditRow}
        refreshKey={refreshKey}
        onRefresh={() => setRefreshKey((prev) => prev + 1)}
      />
    </>
  );
};

export default reduxForm({
  form: "ApiAgentMarkup",
  validate,
})(ApiAgentMarkup);

